export default "__VITE_ASSET__BRKPaQ8l__"